import { useMemo } from 'react';

import { useUserpilotEventHandlers } from './useUserpilotEventHandlers';

import { getUserpilotGlobal } from './getUserpilotGlobal';

/**
 * useUserpilot: Returns access to userpilot, in the form of:
 * - a subset of the userpilot javascript API
 * - additional SWS defined functionality
 *
 * Note: requires SetupUserpilot.tsx to be rendered to load userpilot script
 */
export function useUserpilot() {
  const userpilot = getUserpilotGlobal();
  const { addEventHandler, removeEventHandler } = useUserpilotEventHandlers();

  return useMemo(() => {
    if (typeof userpilot === 'undefined') {
      return;
    }

    const identify: typeof userpilot['identify'] = (...args) => {
      userpilot.identify(...args);
      userpilot.reload();
    };

    return {
      identify,
      addEventHandler,
      removeEventHandler,
      trigger: userpilot.trigger,
    };
  }, [userpilot, addEventHandler, removeEventHandler]);
}
